import { useModal } from '@/storybook/modal/useModal';
import { useUserStore } from '@/store/useUserStore';
import { TrackEvents, useTrack } from '@/composables/useTrack';
import { useCampaignModalsStore } from '@/store/useCampaignModalsStore';
import CampaignModal from '@/components/CampaignModal.vue';

export const useCampaignModals = () => {
  const campaignModalsStore = useCampaignModalsStore();
  const userStore = useUserStore();
  const { trackItemOwner } = useTrack();

  const openCampaignModal = () => {
    const { open } = useModal(CampaignModal, {
      layoutProps: {
        onOpened: () => {
          const { target, title, body, actionLink, actionText } = campaignModalsStore.activeCampaignAttributes;
          trackItemOwner(TrackEvents.CAMPAIGN_MODAL_VIEWED, {
            user_hashid: userStore.id,
            target,
            title,
            body,
            action_link: actionLink,
            action_text: actionText,
            viewer: 'copernicus',
          });
        },
        onClosed: () => {
          campaignModalsStore.loadedTarget && campaignModalsStore.deleteAll(campaignModalsStore.loadedTarget);
        },
      },
    });

    return open();
  };

  return { openCampaignModal };
};
